import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const quag576: IProductData = {
  id: "quag-576",
  name: "Quagliardi 576",
  description: "576 FET Compressor.",
  images: ["/img/quag_576_front.png", "/img/quag_576_right.png"],
  details: [{
    label: "Description",
    markdown: `
The 576 FET Compressor is a 500-series module compatible with any chassis operating within the VPR Alliance standard.
It is ideal for tracking audio channels and for use on the mix bus of a track, given its ability to link with another identical module, thereby connecting parameters that determine the amount of compression applied to the audio signal.
As the name suggests, the 576 FET Compressor uses a BF245 FET-type transistor to control signal amplification. This compression is found in the legendary UREI 1176 compressors, which have left an indelible mark on the history of pro audio.
In a landscape crowded with 1176 clones, we aspired to innovate. The inherent FET topology ensures user-friendly controls, while this hybrid design introduces our custom transformers, a 2520-like op-amp, parallel compression, and other exclusive features, resulting in a distinct and exceptional audio tool.
`
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://quagliardiaudio.com/500-series-modules/" target="_blank">https://quagliardiaudio.com/500-series-modules/</a>
- <a to="https://drive.google.com/file/d/1N9uDR7Pc4vihxzZx7mpLXC20S3JNTd_C/view" target="_blank">576 Manual</a>
    `
  }],
  metadata: {
    hashtags: [HASHTAGS.COMPRESSOR, HASHTAGS.SINGLE_SLOT, HASHTAGS.RECORDING, HASHTAGS.MASTERING, HASHTAGS.MIXING, HASHTAGS.API_500],
    manufacturer: BRAND.QUAGLIARDI,
  }
}